module.exports = __webpack_public_path__ + "img/588x310-03.31ed2199.png";